import { gql } from '@apollo/client';

export const CLAIM_ITEM_FIELDS = gql`
    fragment ClaimItemFields on claim_items {
        claim_item_id
        claim_id
        reason
        amount
        item_id
        description
        images
        documents
    }
`;
